export enum EUserOrgRole {
    Business = "Business",
    Admin = "Admin",
    VR = "Virtual Receptionist",
    Manager = "Manager",
}

const ROLE_NORMALIZE_MAP: Record<string, EUserOrgRole> = {
    business: EUserOrgRole.Business,
    admin: EUserOrgRole.Admin,
    virtualreceptionist: EUserOrgRole.VR,
    "virtual receptionist": EUserOrgRole.VR,
    vr: EUserOrgRole.VR,
    accountmanager: EUserOrgRole.Manager,
    "account manager": EUserOrgRole.Manager,
    manager: EUserOrgRole.Manager,
};

export const normalizeRole = (role?: string): EUserOrgRole =>
    ROLE_NORMALIZE_MAP[(role || "").trim().toLowerCase()] ?? EUserOrgRole.Admin;